import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"

export default function useGetCourses() {
  const query = useQuery({
    queryKey: ["get-courses"],
    queryFn: () => api.cronos.courses.get(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return query
}
